<script setup lang="ts">
import { onMounted, ref } from 'vue';
import WujieVue from 'wujie-vue2';
import { MICRO_NAME, MICRO_URL } from './constants';
import { injectService } from '@patsnap/tahiti-core';
import { HiroEntryService } from './service/hiro-entry.service';
import { GetHiroBasic } from '@/infrastructure/api-functions/core-search-api/get-hiro-basic-api';
import _ from 'lodash';
import { InstanceofPlugin } from 'wujie-polyfill';

const hiroEntryService = injectService<HiroEntryService>(HiroEntryService);

const wujieProps = hiroEntryService.getWujieProps();

const enabled = ref(false);

const hiroBasicService = injectService<GetHiroBasic>(GetHiroBasic);

onMounted(async () => {
    const res = await hiroBasicService.getHiroBasic();
    enabled.value = _.get(res, 'copilot_flag', false);
});

</script>

<template>
    <WujieVue
        v-if="enabled"
        :name="MICRO_NAME"
        :url="MICRO_URL"
        :props="wujieProps"
        :plugins="[InstanceofPlugin()]"
        class="pa-relative pa-z-[9999]"
    />
</template>
